import cx from 'clsx';
import React from 'react';

import style from './style.module.scss';

export type TVariant = 'standard' | 'high' | 'critical';

interface IProps {
  variant: TVariant;
  text: string;
  className?: string;
}

const StatusLabel: React.FC<IProps> = ({ variant, text, className }) => {
  return <div className={cx(style.label, style[variant], className)}>{text}</div>;
};

export default StatusLabel;
